import { BannerType, ICustomizedBanner } from "@next-platform/client-common-core";
import React, { Fragment } from "react";

import { CmsBanner } from "@/components";
import useCharacterCardGridConfig from "@/hooks/useCharacterCardGridConfig";

interface CharacterGridChildProps {
  isHidden?: boolean;
}

interface CharacterGridProps {
  children: React.ReactNode;
  numberOfColumns: number;
  inlineBannerMapping?: Record<number, ICustomizedBanner[]>;
  isTagsSelected?: boolean;
}

const CharacterGrid = ({ children, numberOfColumns, inlineBannerMapping = {}, isTagsSelected = false }: CharacterGridProps) => {
  const { colWidth, colGap } = useCharacterCardGridConfig();

  const childrenArray = React.Children.toArray(children);

  const shouldShowInlineBanner = (index: number) => {
    const totalNumberOfRows = childrenArray.length / numberOfColumns;
    const itemRowNumber = index / numberOfColumns;
    return totalNumberOfRows > itemRowNumber && !isTagsSelected;
  };

  return (
    <div
      className={`grid max-mob:!grid-cols-2`}
      style={{
        gridTemplateColumns: `repeat(auto-fill, minmax(${colWidth}px, 1fr))`,
        gap: colGap,
      }}
    >
      {childrenArray.map((child, originalIndex) => {
        const childElement = child as React.ReactElement<CharacterGridChildProps>;
        if (childElement?.props?.isHidden) {
          return null;
        }

        const visibleIndex = childrenArray.slice(0, originalIndex).filter((item) => {
          const itemElement = item as React.ReactElement<CharacterGridChildProps>;
          return !itemElement?.props?.isHidden;
        }).length;

        return (
          <Fragment key={originalIndex}>
            {inlineBannerMapping[visibleIndex / numberOfColumns]?.length && shouldShowInlineBanner(visibleIndex) && (
              <div className="w-full col-span-full">
                <CmsBanner
                  placement={BannerType.Inline}
                  isVisibleOnPartner={false}
                  availableBanners={inlineBannerMapping[visibleIndex / numberOfColumns]}
                />
              </div>
            )}
            {child}
          </Fragment>
        );
      })}
    </div>
  );
};

export default CharacterGrid;
